import React from 'react';
import CorporateLocation from './CorporateLocation';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import classNames from 'classnames';
const CorporateLocations = (props) => {
    let { locations, aggregationType } = props;
    const tabHeading = (text) => {
        return React.createElement(`h${props.headingindex}`, { className: 'font__subtitle' }, text);
    };
    const countryHeading = (text, tabid) => {
        let headingindex = tabid ? props.headingindex + 1 : props.headingindex;
        return React.createElement(`h${headingindex}`, { className: 'visually-hidden' }, text);
    };
    const locationHeading = (tabid, cTitle) => {
        let headingindex = props.headingindex;
        if (typeof tabid != 'undefined')
            headingindex++;
        if (!!cTitle)
            headingindex++;
        return headingindex;
    };
    const contryContent = (country, tabkey) => {
        const locations = country.locations.filter((loc) => loc.tabid === tabkey);
        return (React.createElement("div", { className: classNames('corporate-locations_row', { 'is-multiloc': locations.length > 1 }), id: country.id },
            country.title && countryHeading(country.title, tabkey),
            React.createElement("ul", { className: "locations" }, locations.map((location) => (React.createElement("li", { key: location.ID },
                React.createElement(CorporateLocation, { headingindex: locationHeading(tabkey, country.title), location: location })))))));
    };
    return (React.createElement(React.Fragment, null, (aggregationType === 'tab' && (React.createElement(Tabs, { className: "tabs" },
        React.createElement(TabList, null, Object.keys(locations.tabs).map((_key) => {
            return React.createElement(Tab, { key: _key }, locations.tabs[_key].title);
        })),
        React.createElement("div", { className: "corporate-locations_panels" }, Object.keys(locations.tabs).map((_key) => (React.createElement(TabPanel, { key: _key },
            locations.tabs[_key].title && tabHeading(locations.tabs[_key].title),
            React.createElement("div", { className: "corporate-locations_panel" }, Object.keys(locations.tabs[_key].countries).map((_ckey) => contryContent(locations.tabs[_key].countries[_ckey], _key)))))))))) || React.createElement("div", { className: "corporate-locations_panel" }, Object.keys(locations.countries).map((_key) => contryContent(locations.countries[_key])))));
};
CorporateLocations.defaultProps = {
    headingindex: 2,
};
export default CorporateLocations;
